import { render } from "./BlockPreview.vue?vue&type=template&id=fecfb0c6&scoped=true"
import script from "./BlockPreview.vue?vue&type=script&lang=js"
export * from "./BlockPreview.vue?vue&type=script&lang=js"

import "./BlockPreview.vue?vue&type=style&index=0&id=fecfb0c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fecfb0c6"]])

export default __exports__